import { apiClient } from "./client";
import type { Paginated, PageQuery } from "@/types/common";

export interface AuditLogRow {
  id: string;
  userId: string | null;
  userName: string | null;
  userLogin: string | null;
  userRole: string | null;
  action: string;
  entityType: string;
  entityId: string | null;
  metadata: unknown;
  ip: string | null;
  createdAt: string;
}

export interface AuditQuery extends PageQuery {
  userId?: string;
  action?: string;
  entityType?: string;
  q?: string;
  from?: string;
  to?: string;
}

export async function fetchAuditLogs(query: AuditQuery = {}): Promise<Paginated<AuditLogRow>> {
  const { data } = await apiClient.get<Paginated<AuditLogRow>>("/audit", { params: query });
  return data;
}

export async function downloadAuditCsv(query: AuditQuery = {}): Promise<void> {
  const response = await apiClient.get("/audit/export", { params: query, responseType: "blob" });
  const url = URL.createObjectURL(response.data as Blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = "proschool-audit.csv";
  anchor.click();
  URL.revokeObjectURL(url);
}
